// extracted by mini-css-extract-plugin
module.exports = {"container":"gf","block":"hf","subheading":"if","cta":"jf","disabled":"kf","noBotMargin":"lf","light":"mf"};